import Vue from 'vue';
import Router from 'vue-router';
import Rounds from '@/components/Rounds';
import Tickets from '@/components/Tickets';
import Jackpots from '@/components/Jackpots';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Tickets',
      component: Tickets,
    },
    {
      path: '/rounds',
      name: 'Rounds',
      component: Rounds,
    },
    {
      path: '/jackpots',
      name: 'Jackpots',
      component: Jackpots,
    },
  ],
});
